module.exports = __webpack_public_path__ + "img/carnival-internet-logo.9a50b107.svg";